import { useLocation } from 'react-router-dom'
import { FiChevronRight, FiHome } from 'react-icons/fi'
import './Breadcrumb.css'

const ROUTES = [
    { match: '/horimetro/edit',   crumbs: ['Manutenção', 'Serviços e Prazos', 'Editar'] },
    { match: '/horimetro/list',   crumbs: ['Manutenção', 'Serviços e Prazos'] },
    { match: '/system-user/edit', crumbs: ['Administrador', 'Editar Usuário'] },
    { match: '/system-user/new',  crumbs: ['Administrador', 'Adicionar Usuário'] },
    { match: '/system-user/list', crumbs: ['Administrador', 'Exibir Usuários'] },
    { match: '/Historic/list',    crumbs: ['Administrador', 'Histórico'] },
    { match: '/historic/list',    crumbs: ['Administrador', 'Histórico'] },
    { match: '/backup',           crumbs: ['Administrador', 'Backup'] },
    { match: '/serviceOrder',     crumbs: ['Manutenção', 'Ordem de Serviço'] },
    { match: '/region/list',      crumbs: ['Início', 'Regiões'] },
    { match: '/generator',        crumbs: ['Início', 'Geradores'] },
    { match: '/myclient',         crumbs: ['Início', 'Meus Clientes'] },
    { match: '/client',           crumbs: ['Início', 'Clientes'] },
]

const HIDDEN = ['/login', '/register']

function Breadcrumb() {
    const { pathname } = useLocation()

    if (HIDDEN.includes(pathname)) return null

    const route = ROUTES.find(r => pathname.startsWith(r.match))
    if (!route) return null

    return (
        <nav className="breadcrumb-bar">
            <FiHome size={12} className="breadcrumb-home" />
            {route.crumbs.map((crumb, i) => (
                <span key={i} className="breadcrumb-item">
                    <FiChevronRight size={12} className="breadcrumb-sep" />
                    <span className={i === route.crumbs.length - 1 ? 'breadcrumb-current' : 'breadcrumb-parent'}>
                        {crumb}
                    </span>
                </span>
            ))}
        </nav>
    )
}

export default Breadcrumb
